import SbEditable from "@mkt/ui/components/common/SbEditable"
import { storyblokEditable } from "@storyblok/react"
import { Text } from "iq-blueberry"
import { render } from "storyblok-rich-text-react-renderer"
import Img from "@mkt/ui/components/common/Img"
import * as S from "./styles.js"

import useTabControl from "./hook"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const Tabs = ({ content }) => {
  const { registerTitle, registerPanel } = useTabControl()

  return (
    <SbEditable css={S.tabs} content={content}>
      <div css={S.tabsContainer} {...storyblokEditable(content)}>
        <div>
          <Text css={S.tabsTitle} as="h2" weight="700" variant="heading-three">
            {content?.title}
          </Text>
          {content?.text && <div css={S.tabsText}>{render(content?.text)}</div>}
          {content?.image && (
            <Img
              css={S.tabsImg}
              src={assertAssetURL(content?.image.filename)}
              alt={`Consumidor Positivo - ${content?.title}`}
            />
          )}
        </div>
        <div data-tabs-container>
          <div css={S.tabTitles}>
            {content?.tabs?.map(({ name }, index) => (
              <div
                css={S.tabItemTitle}
                data-item={index}
                ref={(el) => registerTitle(el)}
                key={index}
              >
                {name}
              </div>
            ))}
          </div>
          <div>
            {content?.tabs?.map(({ name, description }, index) => (
              <div
                css={S.tabItemDescription}
                data-item={index}
                ref={(el) => registerPanel(el)}
                key={index}
              >
                <div css={S.tabItemDescriptionTitle}>{name}</div>
                {render(description)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </SbEditable>
  )
}

export default Tabs
